const e = {
  name: "BottleBeer",
  dimensions: { width: 18, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 40" style="enable-background:new 0 0 18 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,0H5v11.6c-3.2,3.4-5,7.8-5,12.5V40h18V23h0c-0.3-4.3-2-8.3-5-11.4V0z M16,23H5v12h11v3H2V24.1
			c0-4.3,1.7-8.4,4.7-11.4L7,12.4V6h4v6.4l0.3,0.3C14.1,15.5,15.7,19.1,16,23z M11,2v2H7V2H11z M16,28H9v2h7v3H7v-8h9V28z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as BottleBeer
};
